import Flex from '@decisiv/ui-components/lib/components/Flex';
import Pagination from '@decisiv/ui-components/lib/components/Pagination';

import { usePaginatedList } from 'hooks/usePaginatedList';
import AssetRow from '../../components/AssetRow';
import { formatYmm } from '../../utils/formatYmm';

import { Container } from './styles';
import { useAddAssetContext } from '../../context/AddAssetContext';
import { ITEMS_PER_PAGE } from '../constants';

export default function OwnedByAnotherDepot() {
  const {
    savedState: {
      stepTwo: { usedByOtherDepot },
    },
  } = useAddAssetContext();

  const { activePage, items, setCurrentPage, totalPages } = usePaginatedList({
    items: usedByOtherDepot,
    perPage: ITEMS_PER_PAGE,
  });

  return (
    <>
      <Container>
        {items.map(({ make, model, year, vin }) => (
          <AssetRow key={vin} vin={vin} ymm={formatYmm(year, make, model)} />
        ))}
      </Container>
      {totalPages > 1 && (
        <Flex marginTop={1} alignSelf="flex-end">
          <Pagination
            totalPages={totalPages}
            activePage={activePage}
            onPageChange={setCurrentPage}
            defaultActivePage={1}
          />
        </Flex>
      )}
    </>
  );
}
